module.exports = __webpack_public_path__ + "img/bf8acbc.jpg";